import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The strangestest Hello World I ever made",
  "description": "",
  "published": "2010-08-19T00:00:00.000Z",
  "redirect_from": ["/blog/the-strangestest-hello-world-i-ever-made/swizec/1429"],
  "categories": "Compiler, Languages, Lisp, Murray, Open source, Programming, Programming language, python, Turing completeness, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/48298733@N07/4906662333"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/08/4906662333_7139b3e5cf_m.jpg",
              "alt": "Le Belem",
              "title": "Le Belem"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/48298733@N07/4906662333"
          }}>{`0k1n`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Earlier this week while under the influence of being stressed out of my mind being CEO of a startup and watching way too much Sherlock (there are only three episodes, watched every one at least four times) I decided that it was time for a new hobby.`}</p>
    <p>{`The only requirements for said hobby were:`}</p>
    <ul>
      <li parentName="ul">{`mentally very bloody stimulating`}</li>
      <li parentName="ul">{`doable in polynomic time (rules out things like 'invent cold fusion')`}</li>
      <li parentName="ul">{`learn something new`}</li>
    </ul>
    <p>{`Obviously the only real solution to this problem is designing a new `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Programming_language",
        "title": "Programming language"
      }}>{`programming language`}</a>{` and making a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Compiler",
        "title": "Compiler"
      }}>{`compiler`}</a>{` or `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Interpreter_%28computing%29",
        "title": "Interpreter (computing)"
      }}>{`interpreter`}</a>{` for it. Sure, the other obvious solution is to find a cool opensource project and become an Important Contributor (tm). But I'm gonna do that anyway, contribute code I'm developing at Preona to opensource projects that is.`}</p>
    <p>{`No I needed something completely different. Totally unrelated to my daily work and so on. Making a language it was!`}</p>
    <p>{`Because @skatey reminded me of Monkey Island earlier that day the language is called `}<a parentName="p" {...{
        "href": "http://github.com/Swizec/Murray"
      }}>{`Murray`}</a>{`.`}</p>
    <p>{`Murray is a talking demonic skull in Monkey Island.`}</p>
    <p>{`This led to some interesting design ideas. Since obviously the language needs to be inspired by the demonic talking skull ... so let's make the whole thing behave like you're talking to the computer rather than programming.`}</p>
    <p>{`Oh also I wanted it to run on Python and be inspired by `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lisp_%28programming_language%29",
        "title": "Lisp (programming language)"
      }}>{`Lisp`}</a>{`, but without parentheses. No parentheses if at all avoidable!`}</p>
    <p>{`Another big design goal is to eventually write a Murray-to-Python compiler in `}<a parentName="p" {...{
        "href": "http://github.com/Swizec/Murray"
      }}>{`Murray`}</a>{`. Right now I'm writing it in Python.`}</p>
    <p>{`So let's recap the primary design goals`}</p>
    <ul>
      <li parentName="ul">{`functional`}</li>
      <li parentName="ul">{`no parentheses`}</li>
      <li parentName="ul">{`as akin to talking as possible`}</li>
      <li parentName="ul">{`can compile itself`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Turing_completeness",
          "title": "Turing completeness"
        }}>{`Turing complete`}</a></li>
    </ul>
    <h3 {...{
      "id": "the-hello-world"
    }}>{`The hello world`}</h3>
    <p>{`The hello world turns out to be pretty simple.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-murray"
      }}>{`say "Hello World"
`}</code></pre>
    <p>{`Compiles to python and works. And no, no I'm not just using a regex to replace 'say' with 'print'. I actually wrote a parser for this thing.`}</p>
    <p>{`Everything that sticks together is considered a paragraph of code and will essentially evaluate to a big `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Function_composition",
        "title": "Function composition"
      }}>{`function composition`}</a>{` like so f(g(h(x))). Ok? ok.`}</p>
    <p>{`So when I write this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-murray"
      }}>{`say "hello world" say "meow" say "hai"
`}</code></pre>
    <p>{`It compiles into something a bit like so: say( "hello world", say("meow", say("hai")))`}</p>
    <p>{`So the output becomes:`}</p>
    <p>{`hai
None meow
None hello world`}</p>
    <p>{`Which doesn't seem too logical, the None should go on the other side ... I should fix this.`}</p>
    <p>{`But anyway, the None is there because 'say' doesn't return anything, we can fix the wonky output like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-murray"
      }}>{`say "hello world". say "meow". say "hai"
`}</code></pre>
    <p>{`What magic buffonery is this!?`}</p>
    <p>{`Well the dot is another function again and `}<a parentName="p" {...{
        "href": "http://github.com/Swizec/Murray"
      }}>{`Murray`}</a>{` can understand one-char functions even when they are attached to something else. The dot is a simple function anyway, it sort of 'destroys' output by returning an empty string so it doesn't get in the way later on in the execution stack.`}</p>
    <p>{`But what about them code paragraphs I mentioned earlier? Well their intended use eventually is to define 'functions', but I haven't figured this out too much yet. Right now they just do this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-murray"
      }}>{`say "meow1"

say "meow2"
`}</code></pre>
    <p>{`This compiles into two distinct function calls so the output is like this:`}</p>
    <p>{`meow1
meow2`}</p>
    <p>{`Anyway, that's all I've got figured out so far. It's only been a few days since I started working on this and there's a long way still to go. Suggestions very welcome, contributors appreciated, everything is `}<a parentName="p" {...{
        "href": "http://www.wikinvest.com/concept/Open_Source",
        "title": "Open Source"
      }}>{`open source`}</a>{` and living on `}<a parentName="p" {...{
        "href": "http://github.com/Swizec/Murray"
      }}>{`github`}</a>{`. Just fork and ping me about it if you're interested :)`}</p>
    <p>{`Oh yeah, this Hello World is strange because it took me writing a compiler and making up a lot of stuff.`}</p>
    <h6 {...{
      "id": "related-articles-by-zemanta"
    }}>{`Related articles by Zemanta`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://kirkwylie.blogspot.com/2010/08/i-want-new-programming-language.html"
        }}>{`I Want A New Programming Language`}</a>{` (kirkwylie.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.reddit.com/r/programming/comments/280is/is_lisp_secretly_the_worlds_most_popular/"
        }}>{`Is Lisp secretly the world's most popular programming language? : programming`}</a>{` (reddit.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.paulgraham.com/icadmore.html"
        }}>{`Re: Revenge of the Nerds`}</a>{` (paulgraham.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lambda-the-ultimate.org/node/1646"
        }}>{`Lisp sans (((paren-theses ((hell))))) | Lambda the Ultimate`}</a>{` (lambda-the-ultimate.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.licenser.net/2010/07/08/on-parentheses"
        }}>{`lice! : On Parentheses`}</a>{` (licenser.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thecleancoder.blogspot.com/2010/08/why-clojure.html"
        }}>{`The Clean Coder: Why Clojure?`}</a>{` (thecleancoder.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.oreillynet.com/onlamp/blog/2005/12/why_lisp_still_hasnt_won.html"
        }}>{`Why Lisp Still Hasn't Won - O'Reilly ONLamp Blog`}</a>{` (oreillynet.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/162577/Help-me-find-something-new-to-do-with-my-time"
        }}>{`Help me find something new to do with my time`}</a>{` (ask.metafilter.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0f444050-7748-4c28-8a4c-b172081bb171",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      